/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BookingUserPageDto,
  ClientMembershipPageDto,
  ClientReferencePageDto,
  ClientUserDto,
  ContractUserDto,
  CreateUserRequestDto,
  DocumentsDto,
  DocumentsMetadataDto,
  GetBookingUsersParams,
  IdentityUserPageDto,
  PasswordResetRequestDto,
  SearchUsersParams,
  SendNotificationRequest,
  UpdateUserRequestDto,
  UserReferenceDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * Asks the identity provider to e-mail a password-reset link to the account with the given address.
 * @summary Send password reset email
 */
export const resetPassword = (
    passwordResetRequestDto: BodyType<PasswordResetRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<null>(
      {url: `/fleet/client/v1/admin/password-resets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetRequestDto, signal
    },
      );
    }
  


export const getResetPasswordMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: BodyType<PasswordResetRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: BodyType<PasswordResetRequestDto>}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: BodyType<PasswordResetRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = BodyType<PasswordResetRequestDto>
    export type ResetPasswordMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Send password reset email
 */
export const useResetPassword = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: BodyType<PasswordResetRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: BodyType<PasswordResetRequestDto>},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns the same contract user as GET /client/v1/admin/users/{userId}/details, looked up by Remote ID (the identity-provider subject) instead of the contract service's numeric id. Bookings carry only the driver's Remote ID. A person can have a Remote ID without a contract user; that answers 404, with no fallback to booking-user data. Save edits through PUT /client/v1/admin/users/{userId}/details with the numeric id from this response.
 * @summary Get user details by Remote ID (admin)
 */
export const getUserDetailsByRemoteId = (
    remoteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContractUserDto>(
      {url: `/fleet/client/v1/admin/users/by-remote-id/${remoteId}/details`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserDetailsByRemoteIdQueryKey = (remoteId?: string,) => {
    return [`/fleet/client/v1/admin/users/by-remote-id/${remoteId}/details`] as const;
    }

    
export const getGetUserDetailsByRemoteIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError = ErrorType<null | null | null | null | null>>(remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDetailsByRemoteIdQueryKey(remoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>> = ({ signal }) => getUserDetailsByRemoteId(remoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(remoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserDetailsByRemoteIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>>
export type GetUserDetailsByRemoteIdQueryError = ErrorType<null | null | null | null | null>


export function useGetUserDetailsByRemoteId<TData = Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError = ErrorType<null | null | null | null | null>>(
 remoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetailsByRemoteId>>,
          TError,
          Awaited<ReturnType<typeof getUserDetailsByRemoteId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserDetailsByRemoteId<TData = Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError = ErrorType<null | null | null | null | null>>(
 remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetailsByRemoteId>>,
          TError,
          Awaited<ReturnType<typeof getUserDetailsByRemoteId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserDetailsByRemoteId<TData = Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError = ErrorType<null | null | null | null | null>>(
 remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user details by Remote ID (admin)
 */

export function useGetUserDetailsByRemoteId<TData = Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError = ErrorType<null | null | null | null | null>>(
 remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetailsByRemoteId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserDetailsByRemoteIdQueryOptions(remoteId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns one contract user by contract-service id, including licence, address and conviction records, plus the clients they hold a subscription with. The id is the contract service's own numeric id, not the identity-provider remote id.
 * @summary Get user details (admin)
 */
export const getUserDetails = (
    userId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContractUserDto>(
      {url: `/fleet/client/v1/admin/users/${userId}/details`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserDetailsQueryKey = (userId?: number,) => {
    return [`/fleet/client/v1/admin/users/${userId}/details`] as const;
    }

    
export const getGetUserDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getUserDetails>>, TError = ErrorType<null | null | null | null>>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDetailsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDetails>>> = ({ signal }) => getUserDetails(userId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDetails>>>
export type GetUserDetailsQueryError = ErrorType<null | null | null | null>


export function useGetUserDetails<TData = Awaited<ReturnType<typeof getUserDetails>>, TError = ErrorType<null | null | null | null>>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getUserDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserDetails<TData = Awaited<ReturnType<typeof getUserDetails>>, TError = ErrorType<null | null | null | null>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getUserDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserDetails<TData = Awaited<ReturnType<typeof getUserDetails>>, TError = ErrorType<null | null | null | null>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user details (admin)
 */

export function useGetUserDetails<TData = Awaited<ReturnType<typeof getUserDetails>>, TError = ErrorType<null | null | null | null>>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserDetailsQueryOptions(userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Replaces the mutable details of one contract user and returns the updated record with its clients resolved. A full update, not a partial merge: fields omitted from the body are cleared.
 * @summary Update user details (admin)
 */
export const updateUserDetails = (
    userId: number,
    updateUserRequestDto: BodyType<UpdateUserRequestDto>,
 ) => {
      
      
      return customInstance<ContractUserDto>(
      {url: `/fleet/client/v1/admin/users/${userId}/details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequestDto
    },
      );
    }
  


export const getUpdateUserDetailsMutationOptions = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserDetails>>, TError,{userId: number;data: BodyType<UpdateUserRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUserDetails>>, TError,{userId: number;data: BodyType<UpdateUserRequestDto>}, TContext> => {

const mutationKey = ['updateUserDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserDetails>>, {userId: number;data: BodyType<UpdateUserRequestDto>}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUserDetails(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserDetails>>>
    export type UpdateUserDetailsMutationBody = BodyType<UpdateUserRequestDto>
    export type UpdateUserDetailsMutationError = ErrorType<null | null | null | null | null>

    /**
 * @summary Update user details (admin)
 */
export const useUpdateUserDetails = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserDetails>>, TError,{userId: number;data: BodyType<UpdateUserRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserDetails>>,
        TError,
        {userId: number;data: BodyType<UpdateUserRequestDto>},
        TContext
      > => {

      const mutationOptions = getUpdateUserDetailsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Searches the users booking-engine knows about — the subset of accounts that can hold client memberships and appear on bookings.

Not to be confused with GET /fleet/client/v1/users, which lists every identity-provider account, or with POST /fleet/client/v1/users/searches, which searches contract users by name and phone hints.

`remoteId` matches exactly; `userName` and `displayName` match a case-insensitive substring; `organizationId` matches a membership of that organization. Omitting every criterion returns the first page of all booking users.

`hasMembership` is a tri-state filter: `true` keeps only users holding at least one membership, `false` keeps only those holding none, and omitting it applies no filter.

Results are deduplicated by remote id — the organization filter joins memberships and would otherwise return a user once per membership — then ordered by display name (case-insensitive, users without one last) and paged. `totalElements` is the size of the filtered, deduplicated set, not of the returned page.

This is the /fleet replacement for the legacy POST /web-api/user/v1/users/searches.
 * @summary Search booking users
 */
export const getBookingUsers = (
    params?: GetBookingUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingUserPageDto>(
      {url: `/fleet/client/v1/booking-users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBookingUsersQueryKey = (params?: GetBookingUsersParams,) => {
    return [`/fleet/client/v1/booking-users`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBookingUsersQueryOptions = <TData = Awaited<ReturnType<typeof getBookingUsers>>, TError = ErrorType<BookingUserPageDto | BookingUserPageDto | BookingUserPageDto>>(params?: GetBookingUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingUsers>>> = ({ signal }) => getBookingUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingUsers>>>
export type GetBookingUsersQueryError = ErrorType<BookingUserPageDto | BookingUserPageDto | BookingUserPageDto>


export function useGetBookingUsers<TData = Awaited<ReturnType<typeof getBookingUsers>>, TError = ErrorType<BookingUserPageDto | BookingUserPageDto | BookingUserPageDto>>(
 params: undefined |  GetBookingUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingUsers>>,
          TError,
          Awaited<ReturnType<typeof getBookingUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingUsers<TData = Awaited<ReturnType<typeof getBookingUsers>>, TError = ErrorType<BookingUserPageDto | BookingUserPageDto | BookingUserPageDto>>(
 params?: GetBookingUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingUsers>>,
          TError,
          Awaited<ReturnType<typeof getBookingUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingUsers<TData = Awaited<ReturnType<typeof getBookingUsers>>, TError = ErrorType<BookingUserPageDto | BookingUserPageDto | BookingUserPageDto>>(
 params?: GetBookingUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search booking users
 */

export function useGetBookingUsers<TData = Awaited<ReturnType<typeof getBookingUsers>>, TError = ErrorType<BookingUserPageDto | BookingUserPageDto | BookingUserPageDto>>(
 params?: GetBookingUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingUsersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns every account in the realm, capped at the configured maximum. Deliberately unfiltered: disabled and unverified accounts are included, because consumers that build a local mirror need the full set and would silently stop mirroring if this narrowed. Filter client-side if you want a subset.

This is the /fleet replacement for the legacy GET /web-api/user/v1/users. Same source (the identity provider) and same set of users; the response is the standard page envelope rather than the legacy {users:[...]} wrapper.

Not paged: totalElements always equals the number of items. Admin-only.
 * @summary List every user known to the identity provider
 */
export const listAllUsers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<IdentityUserPageDto>(
      {url: `/fleet/client/v1/users`, method: 'GET', signal
    },
      );
    }
  

export const getListAllUsersQueryKey = () => {
    return [`/fleet/client/v1/users`] as const;
    }

    
export const getListAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof listAllUsers>>, TError = ErrorType<IdentityUserPageDto | IdentityUserPageDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllUsers>>> = ({ signal }) => listAllUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listAllUsers>>>
export type ListAllUsersQueryError = ErrorType<IdentityUserPageDto | IdentityUserPageDto>


export function useListAllUsers<TData = Awaited<ReturnType<typeof listAllUsers>>, TError = ErrorType<IdentityUserPageDto | IdentityUserPageDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllUsers>>,
          TError,
          Awaited<ReturnType<typeof listAllUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllUsers<TData = Awaited<ReturnType<typeof listAllUsers>>, TError = ErrorType<IdentityUserPageDto | IdentityUserPageDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllUsers>>,
          TError,
          Awaited<ReturnType<typeof listAllUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllUsers<TData = Awaited<ReturnType<typeof listAllUsers>>, TError = ErrorType<IdentityUserPageDto | IdentityUserPageDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List every user known to the identity provider
 */

export function useListAllUsers<TData = Awaited<ReturnType<typeof listAllUsers>>, TError = ErrorType<IdentityUserPageDto | IdentityUserPageDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllUsersQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Creates a booking-engine user for an account that already exists in the identity provider. The remote id in the request is the identity-provider subject; the e-mail becomes both the username and the display name.
 * @summary Create a new fleet user
 */
export const createUser = (
    createUserRequestDto: BodyType<CreateUserRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserReferenceDto>(
      {url: `/fleet/client/v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequestDto, signal
    },
      );
    }
  


export const getCreateUserMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserRequestDto>}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: BodyType<CreateUserRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = BodyType<CreateUserRequestDto>
    export type CreateUserMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Create a new fleet user
 */
export const useCreateUser = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: BodyType<CreateUserRequestDto>},
        TContext
      > => {

      const mutationOptions = getCreateUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns the caller's own profile, assembled from the identity provider, booking-engine and the onboarding service: the booking user, their onboarding state, and the vehicles they own. Null when the caller has no booking user yet.
 * @summary Get information about your own user
 */
export const getMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ClientUserDto>(
      {url: `/fleet/client/v1/users/me`, method: 'GET', signal
    },
      );
    }
  

export const getGetMeQueryKey = () => {
    return [`/fleet/client/v1/users/me`] as const;
    }

    
export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<null | null>


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get information about your own user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the file names of the onboarding documents the currently authenticated user has uploaded. A user who has uploaded nothing yields an empty list, not a 404. Use the metadata variant when you also need type and expiry.
 * @summary Get your own documents
 */
export const getDocuments = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentsDto>(
      {url: `/fleet/client/v1/users/me/documents`, method: 'GET', signal
    },
      );
    }
  

export const getGetDocumentsQueryKey = () => {
    return [`/fleet/client/v1/users/me/documents`] as const;
    }

    
export const getGetDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocuments>>> = ({ signal }) => getDocuments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocuments>>>
export type GetDocumentsQueryError = ErrorType<null | null>


export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocuments>>,
          TError,
          Awaited<ReturnType<typeof getDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get your own documents
 */

export function useGetDocuments<TData = Awaited<ReturnType<typeof getDocuments>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieves the onboarding documents of the currently authenticated user, including their type, creation date (from blob storage) and expiry date (driver-license documents use the user's license expiry; ID documents currently expose null because the source data is not yet captured).
 * @summary Get your own documents with metadata
 */
export const getDocumentsMetadata = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentsMetadataDto>(
      {url: `/fleet/client/v1/users/me/documents/metadata`, method: 'GET', signal
    },
      );
    }
  

export const getGetDocumentsMetadataQueryKey = () => {
    return [`/fleet/client/v1/users/me/documents/metadata`] as const;
    }

    
export const getGetDocumentsMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentsMetadata>>, TError = ErrorType<null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsMetadata>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsMetadataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentsMetadata>>> = ({ signal }) => getDocumentsMetadata(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentsMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentsMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentsMetadata>>>
export type GetDocumentsMetadataQueryError = ErrorType<null | null>


export function useGetDocumentsMetadata<TData = Awaited<ReturnType<typeof getDocumentsMetadata>>, TError = ErrorType<null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentsMetadata>>,
          TError,
          Awaited<ReturnType<typeof getDocumentsMetadata>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentsMetadata<TData = Awaited<ReturnType<typeof getDocumentsMetadata>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentsMetadata>>,
          TError,
          Awaited<ReturnType<typeof getDocumentsMetadata>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentsMetadata<TData = Awaited<ReturnType<typeof getDocumentsMetadata>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsMetadata>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get your own documents with metadata
 */

export function useGetDocumentsMetadata<TData = Awaited<ReturnType<typeof getDocumentsMetadata>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentsMetadata>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentsMetadataQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the client memberships of the currently authenticated user, each with the vehicles that membership grants access to. A user who belongs to no client yields an empty page, not a 404.
 * @summary Get your own memberships
 */
export const getMyMemberships = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ClientMembershipPageDto>(
      {url: `/fleet/client/v1/users/me/memberships`, method: 'GET', signal
    },
      );
    }
  

export const getGetMyMembershipsQueryKey = () => {
    return [`/fleet/client/v1/users/me/memberships`] as const;
    }

    
export const getGetMyMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMembershipsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMemberships>>> = ({ signal }) => getMyMemberships(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMemberships>>>
export type GetMyMembershipsQueryError = ErrorType<null | null>


export function useGetMyMemberships<TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMyMemberships>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyMemberships<TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMyMemberships>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyMemberships<TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get your own memberships
 */

export function useGetMyMemberships<TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyMembershipsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Searches users as the contract service knows them — licence, address and conviction records — by first name, last name and phone number hints.

This is not the booking-user search: for drivers, display names and usernames use GET /client/v1/booking-users. The criteria travel as query parameters even though the verb is POST; that shape predates the GET-with-query-params convention and is kept for its existing consumers.
 * @summary Search contract users
 */
export const searchUsers = (
    params?: SearchUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContractUserDto[]>(
      {url: `/fleet/client/v1/users/searches`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSearchUsersMutationOptions = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchUsers>>, TError,{params?: SearchUsersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchUsers>>, TError,{params?: SearchUsersParams}, TContext> => {

const mutationKey = ['searchUsers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchUsers>>, {params?: SearchUsersParams}> = (props) => {
          const {params} = props ?? {};

          return  searchUsers(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchUsersMutationResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
    
    export type SearchUsersMutationError = ErrorType<null | null | null>

    /**
 * @summary Search contract users
 */
export const useSearchUsers = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchUsers>>, TError,{params?: SearchUsersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchUsers>>,
        TError,
        {params?: SearchUsersParams},
        TContext
      > => {

      const mutationOptions = getSearchUsersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns one booking-engine user by identity-provider remote id. Use GET /client/v1/booking-users when you need to search rather than resolve a known id.
 * @summary Get fleet user by ID
 */
export const getUser = (
    remoteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserReferenceDto>(
      {url: `/fleet/client/v1/users/${remoteId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserQueryKey = (remoteId?: string,) => {
    return [`/fleet/client/v1/users/${remoteId}`] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<null | null | null | null>>(remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(remoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(remoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(remoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<null | null | null | null>


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<null | null | null | null>>(
 remoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<null | null | null | null>>(
 remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<null | null | null | null>>(
 remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fleet user by ID
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<null | null | null | null>>(
 remoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(remoteId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Removes a user from booking-engine. Deleting yourself is refused, so an administrator cannot lock themselves out.
 * @summary Delete fleet user
 */
export const deleteUser = (
    remoteId: string,
 ) => {
      
      
      return customInstance<null>(
      {url: `/fleet/client/v1/users/${remoteId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{remoteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{remoteId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {remoteId: string}> = (props) => {
          const {remoteId} = props ?? {};

          return  deleteUser(remoteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Delete fleet user
 */
export const useDeleteUser = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{remoteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {remoteId: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Sends a custom push notification, with optional template parameters, to every device the given user has registered. A user with no registered device is not an error — nothing is delivered.
 * @summary Send custom notification to user
 */
export const sendNotification = (
    remoteId: string,
    sendNotificationRequest: BodyType<SendNotificationRequest>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<null>(
      {url: `/fleet/client/v1/users/${remoteId}/notification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendNotificationRequest, signal
    },
      );
    }
  


export const getSendNotificationMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, TError,{remoteId: string;data: BodyType<SendNotificationRequest>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, TError,{remoteId: string;data: BodyType<SendNotificationRequest>}, TContext> => {

const mutationKey = ['sendNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNotification>>, {remoteId: string;data: BodyType<SendNotificationRequest>}> = (props) => {
          const {remoteId,data} = props ?? {};

          return  sendNotification(remoteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendNotification>>>
    export type SendNotificationMutationBody = BodyType<SendNotificationRequest>
    export type SendNotificationMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Send custom notification to user
 */
export const useSendNotification = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, TError,{remoteId: string;data: BodyType<SendNotificationRequest>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendNotification>>,
        TError,
        {remoteId: string;data: BodyType<SendNotificationRequest>},
        TContext
      > => {

      const mutationOptions = getSendNotificationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns the distinct clients the given user holds a membership with, ordered by name. Each client appears once even when the user has several memberships with it. A user with no memberships — or an unknown user — yields an empty page, not a 404. This returns client references only, not the memberships themselves: use it to populate a client picker.
 * @summary Get the clients a user belongs to
 */
export const getClientsForUser = (
    userRemoteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ClientReferencePageDto>(
      {url: `/fleet/client/v1/users/${userRemoteId}/clients`, method: 'GET', signal
    },
      );
    }
  

export const getGetClientsForUserQueryKey = (userRemoteId?: string,) => {
    return [`/fleet/client/v1/users/${userRemoteId}/clients`] as const;
    }

    
export const getGetClientsForUserQueryOptions = <TData = Awaited<ReturnType<typeof getClientsForUser>>, TError = ErrorType<null | null | null>>(userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsForUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientsForUserQueryKey(userRemoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsForUser>>> = ({ signal }) => getClientsForUser(userRemoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userRemoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsForUser>>>
export type GetClientsForUserQueryError = ErrorType<null | null | null>


export function useGetClientsForUser<TData = Awaited<ReturnType<typeof getClientsForUser>>, TError = ErrorType<null | null | null>>(
 userRemoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsForUser>>,
          TError,
          Awaited<ReturnType<typeof getClientsForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsForUser<TData = Awaited<ReturnType<typeof getClientsForUser>>, TError = ErrorType<null | null | null>>(
 userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsForUser>>,
          TError,
          Awaited<ReturnType<typeof getClientsForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientsForUser<TData = Awaited<ReturnType<typeof getClientsForUser>>, TError = ErrorType<null | null | null>>(
 userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsForUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the clients a user belongs to
 */

export function useGetClientsForUser<TData = Awaited<ReturnType<typeof getClientsForUser>>, TError = ErrorType<null | null | null>>(
 userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsForUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientsForUserQueryOptions(userRemoteId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



